import { render, staticRenderFns } from "./-faq-item.vue?vue&type=template&id=0a7acb70&scoped=true&"
import script from "./-faq-item.vue?vue&type=script&lang=js&"
export * from "./-faq-item.vue?vue&type=script&lang=js&"
import style0 from "./-faq-item.vue?vue&type=style&index=0&id=0a7acb70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7acb70",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/SvgIcon.vue').default})
